import type { QueryClient } from '@tanstack/react-query';

/**
 * POST che non cambiano dati, quindi non devono far ricaricare dashboard e
 * previsionale:
 * - l'anteprima della ricorrenza parte a ogni modifica del form, col
 *   previsionale aperto sotto il pannello;
 * - l'avvio asincrono della ricerca proposte (risponde 202 e accoda un job)
 *   parte da solo 1,5 s dopo l'apertura della dashboard: invalidare lì
 *   annullerebbe e rilancerebbe tutte le card ancora in caricamento. Le
 *   proposte arrivano a job finito, con le loro invalidazioni.
 */
const READ_ONLY_POST_PATTERN =
  /\/(?:forecast-series\/preview|reconciliation\/auto-match-cash\/async)(?:[/?]|$)/;

/** Refresh composite dashboard reads after successful financial writes. */
export function invalidateDashboardAfterWrite(
  queryClient: QueryClient,
  request: { method?: string; url?: string }
) {
  if (
    !['post', 'put', 'patch', 'delete'].includes(
      request.method?.toLowerCase() ?? ''
    )
  )
    return;
  if (request.url && READ_ONLY_POST_PATTERN.test(request.url)) return;
  const match = request.url?.match(
    /\/tenants\/([^/?]+)\/(documents|document-payment-schedules|cash-movements|cash-movement-allocations|reconciliation|accounts|account-transfers|forecast[^/?]*)(?:[/?]|$)/
  );
  if (!match) return;
  const tenantId = match[1];
  return queryClient.invalidateQueries({
    predicate: (query) => {
      const key = query.queryKey;
      return (
        (key[0] === 'dashboard' && key[2] === tenantId) ||
        (key[0] === 'cash-flow-forecast' &&
          (key[1] === tenantId || key[2] === tenantId))
      );
    },
  });
}
